/**
 * `requiredUnless` (dynamic form): checkbox key(s) - comma separated - that
 * switch a question off. While any of them is ticked the question is hidden,
 * not required and its answer is ignored (e.g. "שנת טסט" / "חודש טסט" once
 * "ללא טסט" is ticked). Same rule as the app (isFieldSuppressed) and the
 * server (nadlan/services/validators.is_suppressed).
 */
export function requiredUnlessKeys(requiredUnless: string | null | undefined): string[] {
  return String(requiredUnless || '').split(',').map(key => key.trim()).filter(Boolean);
}

export function isTicked(value: any): boolean {
  if (typeof value === 'string') return ['true', '1', 'yes', 'on'].includes(value.trim().toLowerCase());
  return !!value;
}

export function isSuppressedBy(requiredUnless: string | null | undefined, answerOf: (key: string) => any): boolean {
  return requiredUnlessKeys(requiredUnless).some(key => isTicked(answerOf(key)));
}
